import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: {},
};

const serviceSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    shifterStatusUpdate(state, action) {
      state.status = action.payload;
    },
  },
});

export const { shifterStatusUpdate } = serviceSlice.actions;
export default serviceSlice.reducer;
